const brands = ['mi-aem-luxury-spa', 'mi-aem-brands'];

export const identifyBrandsHelper = () => {
  return brands.filter(brand => brand === process.env['NEXT_PUBLIC_APP_NAME']);
};
